var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"label",style:(_vm.labelColor),attrs:{"id":"LabelInput"},on:{"click":function($event){return _vm.itemClick()}}},[_vm._v(" "+_vm._s(_vm.label.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }